import { Observable } from "rxjs";
import { UserToken } from "./model/user-token";

/**
 * Repository used for the internal api endpoints.
 */
export abstract class InternalApiRepo {
  /**
   * Get a user token.
   * @param email
   * @param token user token authentication
   */
  abstract getUserToken(
    email: string,
    token: string
  ): Observable<UserToken>;
}
